var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0078 4C24.0757 4 19.2542 5.4369 15.1533 8.12899C11.0523 10.8211 7.85604 14.6475 5.96858 19.1243C4.08112 23.601 3.58727 28.5272 4.54949 33.2797C5.51171 38.0322 7.88678 42.3977 11.3743 45.8241C14.8619 49.2505 19.3054 51.5839 24.1428 52.5292C28.9802 53.4746 33.9943 52.9894 38.551 51.135C43.1077 49.2807 47.0024 46.1405 49.7426 42.1115C52.4828 38.0825 53.9453 33.3456 53.9453 28.5C53.9453 22.0022 51.318 15.7705 46.6413 11.1759C41.9646 6.58124 35.6217 4 29.0078 4ZM25.4453 38.2825L16.5391 29.5325L19.3713 26.75L25.4453 32.7175L38.6444 19.75L41.4873 22.5255L25.4453 38.2825Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkWhite.bdcfa757.svg";
export { ForwardRef as ReactComponent };